// extracted by mini-css-extract-plugin
export default {"loginDetails":"style_loginDetails__+5CT2","bgContent":"style_bgContent__yzSMh"};